import { RichTextBlock } from '@components/rich-text-block'
import SmallContainer from '@components/ui/layout/SmallContainer'
import { blogNarrowWidth, spacingBottomM } from '@components/_blog-detail/spacings'
import { cx } from '@linaria/core'
import React, { FC } from 'react'
import { CbRichContent as CbRichContentModel } from '__generated__/sanity'

type CbRichContentProps = CbRichContentModel

export const CbRichContent: FC<CbRichContentProps> = ({ contentText }) => {
  return (
    <SmallContainer className={cx(spacingBottomM)}>
      <div className={blogNarrowWidth}>
        <RichTextBlock content={contentText} variant="regular" />
      </div>
    </SmallContainer>
  )
}
